import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, Validators } from '@angular/forms';
import { SweetAlertService } from '../../../core/services/sweet-alert.service';
import { Router } from '@angular/router';
import { SessionService } from '../../../shared/services/session.service';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})

export class LoginComponent {
  loginForm: any;
  constructor(
    private formBuilder: FormBuilder,
    private AuthService: AuthService,
    private swal: SweetAlertService,
    private router: Router,
    private sessionService: SessionService
  ) {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', [Validators.required]],
    });
  }

  submitted = false;
  loading = false;


  async onSubmit() {
    this.submitted = true;
    this.sessionService.removeData();

    if (this.loginForm.invalid) {
      return;
    } else {

      this.loading = true;
      let username = this.loginForm.value.username || '';
      let password = this.loginForm.value.password || '';

      this.AuthService.login({ username, password })
        .subscribe((response: any) => {
          this.loading = false;
          if (response.success) {
            this.sessionService.singIn(response);

            this.swal.toastSuccess('Bienvenido', 1500);
            this.router.navigate(response.profile.init_url);
          } else {
            this.swal.toastWarning('Usuario o contraseña incorrectos');
          }
        }, (error) => {
          this.loading = false;
          this.swal.toastWarning('Usuario o contraseña incorrectos');
        });
    }

  }

  get f() { return this.loginForm.controls; }

}
